var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.77838 0C4.38655 0 0 4.38655 0 9.77832C0 16.4697 8.75069 26.293 9.12326 26.7079C9.4732 27.0977 10.0842 27.097 10.4335 26.7079C10.8061 26.293 19.5568 16.4697 19.5568 9.77832C19.5567 4.38655 15.1702 0 9.77838 0ZM9.77838 14.6981C7.06562 14.6981 4.85868 12.4911 4.85868 9.77832C4.85868 7.06556 7.06567 4.85863 9.77838 4.85863C12.4911 4.85863 14.698 7.06562 14.698 9.77838C14.698 12.4911 12.4911 14.6981 9.77838 14.6981Z","fill":"black"}));
}

Marker.defaultProps = {"width":"20","height":"27","viewBox":"0 0 20 27","fill":"none"};

module.exports = Marker;

Marker.default = Marker;
